import { Redirect, useParams } from "react-router-dom";

export default function NestedUsersPathRedirect() {
  const { userId } = useParams<{ userId: string }>();
  const id = userId?.trim() ?? "";
  if (!id) {
    return <Redirect to="/users" />;
  }
  return <Redirect to={`/user/${encodeURIComponent(id)}`} />;
}
